import React from 'react';
import PropTypes from 'prop-types';

import SimpleOption from './simple_option';
import MultiSelectOption from './multi_select_option';
import SelectOption from './select_option';

export default function Option({ ...props }) {
  const { option } = props;
  let OptionComponent;
  switch (option.type) {
  case 'simple':
    OptionComponent = SimpleOption;
    break;
  case 'multi-select':
    OptionComponent = MultiSelectOption;
    break;
  case 'single-select':
    OptionComponent = SelectOption;
    break;
  }

  return (
    <OptionComponent {...props}/>
  );
}

Option.propTypes = {
  option: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};
